<div class="ui-g loyalty-cluster" *ngIf="render.datatable">
  <div class="ui-g-12" >

    <app-kontable #table data-testid="table" title = "{{ 'self_scan_service.title' | translate }}"
                  [columns] = "['id', 'customer_description',
                  { field: 'birth_date', filterTemplate: noFilter, filterType: noFilter, title: 'self_scan_service.birth_date', bodyTemplate: dateTemplateBirth },
                  'channel_description', 'uid_chk_chance','number_trx_checked','number_trx_used',
                  { field: 'date_last_trx', filterTemplate: noFilter, filterType: noFilter, title: 'self_scan_service.date_last_trx', bodyTemplate: dateTemplateStart },
                  { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter},
                  { field: 'flg_blk_ss', title: 'loyalty.blacklist', bodyTemplate: stateTemplateBl, filterType: customFilter, filterTemplate: stateFilterBl}

                    ]"
                  [titles] = "['common.id', 'self_scan_service.customer_id', 'self_scan_service.channel_id','self_scan_service.uid_chk_chance','self_scan_service.number_trx_checked','self_scan_service.number_trx_used']"
                  [paginationType]="serverPagination"
                  [showInfoButton]="false"
                  [showGlobalFilter]="false"
                  [showDetailsButton]="true"
                  [showAddButton]="false"
                  [showDeleteButton]="false"
                  [showRecoverButton]="false"
                  [service]="selfscanService"
                  [servicePermissions]="selfScanningPermissions"
                  [(fireNewDataAvailable)]="newDataAvailable"
                  (onEdit)="edit($event)"
                  (onDetails)="onOpen($event)"
                  >

      <ng-template #dateTemplateBirth data-testid="dateTemplateBirth" let-row>
        <span>{{ row['birth_date'] | date:'dd/MM/yyyy' }}</span>
      </ng-template>

      <ng-template #dateTemplateStart data-testid="dateTemplateStart" let-row>
        <span>{{ row['date_last_trx']}}</span>
      </ng-template>

      <ng-template #noFilter data-testid="noFilter" let-col>

      </ng-template>

      <ng-template #stateTemplate data-testid="stateTemplate" let-row class="deleted-row">
        <span *ngIf="row.flg_state == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
        <span *ngIf="row.flg_state == '2'" class="fa fa-ban" title="{{'common.suspended' | translate}}"></span>
      </ng-template>

      <ng-template #stateTemplateBl data-testid="stateTemplateBl" let-row class="deleted-row">
        <span *ngIf="row.flg_blk_ss == '1'" class="fa fa-trash-o" title="{{'loyalty.blacklist' | translate}}"></span>
        <span *ngIf="row.flg_blk_ss == '2'" class="fa fa-ban" title="{{'common.suspended' | translate}}"></span>
      </ng-template>

      <ng-template #stateFilter data-testid="stateFilter" let-col>
        <p-dropdown [options]="listStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>

      <ng-template #stateFilterBl data-testid="stateFilterBl" let-col>
        <p-dropdown [options]="listStatesBl" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
      </ng-template>


    </app-kontable>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-self-scan-service/loyalty-self-scan-service.component.html